// extracted by mini-css-extract-plugin
module.exports = {"container":"ChatInput_container__gJxHc","buttonContainer":"ChatInput_buttonContainer___6LUO","label":"ChatInput_label__wTeee","input":"ChatInput_input__Epf1q"};